<template>
    <section class="home-top-page">
        <img src="../../assets/images/home/top/bg.png" class="bg" alt="bg">
        <video muted preload class="video-bg" id="home-top-bg" autoplay loop :src="topBgUrl" @canplaythrough="loaded"></video>
        <!-- right-nav -->
        <div class="right-nav">
            <div class="box-wrap">
                <div class="pv-box">
                    <span class="pv-box-tip">PV</span>
                    <a v-for="(item, index) in pvList" :key="`pv-${index}`" href="javascript: void(0);" @click="updateVideo(item.youtubeUrl !== '', item)" class="pv-box-a" :class="{ 'active': item.name === currentVideo }" >{{ item.text }}</a>
                </div>
                <div class="faction-box">
                    <span class="faction-box-tip">CV</span>
                    <a href="javascript: void(0);" class="faction-box-a" :class="{'active': item.name === currentVideo }" v-for="(item, index) in factionList" :key="`faction-${index}`" @click="updateVideo(item.open, item)">
                        <img :src="item.icon" alt="">
                    </a>
                </div>
            </div>
            
            <div class="other-nav">
                <a :href="item.to" target="_blank" class="link-box" v-for="(item, index) in linkList" :key="`link-${index}`">
                    <img :src="item.icon" alt="">
                </a>
            </div>
        </div>
        <!-- btn-wrap -->
        <div class="btn-wrap">
            <img src="../../assets/images/home/top/play_btn.png" :class="{ 'active': videoPlayBtnActive }" class="video-play-btn" @click="showVideoMask" alt="">
            <div class="prereg-box">
                <!-- 删除动画黄色菱形 -->
                <!-- <img src="../../assets/images/home/top/prereg_btn.png" @click="jumpTo" class="prereg-img" alt=""> -->

               <!--  <a href="https://apps.apple.com/kr/app/id1473903308?mt=8  " target="_blank" class="pre-ios">
                    <img src="../../assets/images/home/top/pre_ios.png" alt="">
                </a>
                <a href="https://play.google.com/store/apps/details?id=com.YoStarKR.Arknights" target="_blank" class="pre-google">
                    <img src="../../assets/images/home/top/pre_google.png" alt="">
                </a> -->

                <a href="https://play.google.com/store/apps/details?id=com.YoStarKR.Arknights" target="_blank" class="download-google">
                    <img src="../../assets/images/home/top/google_download.png" alt="">
                </a>

                <a href="https://onesto.re/0000749849" target="_blank" class="download-one-store">
                    <img src="../../assets/images/home/top/on_store_download.png" alt="">
                </a>

                <a href="https://apps.samsung.com/appquery/appDetail.as?appId=com.YoStarKR.Samsung.Arknights" target="_blank" class="download-samsung">
                  <img src="../../assets/images/home/top/samsung_download.png" alt="">
                </a>
                
                <a href="https://apps.apple.com/kr/app/id1473903308?mt=8" target="_blank" class="download-ios">
                    <img src="../../assets/images/home/top/ios_download.svg" alt="">
                </a>
                
            </div>
        </div>
        <!-- scroll logo -->
        <div class="scroll-box">
            <img src="../../assets/images/logo_big.png" class="logo" alt="logo">
            <div class="mouse-box">
                <div class="mouse-tip">
                    <img src="../../assets/images/home/top/mouse.png" class="mouse" alt="">
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import {mapState, mapGetters} from 'vuex'

export default {
    name: "home-top",

    components: {
    },
    data: () => ({
        topBgUrl: require("../../assets/video/home_top_bg.mp4"),
        pvList: [
            {
                text: "001",
                youtubeUrl: "https://www.youtube.com/embed/jdeYt1uXD_8",
                name: 'pv001'
            },
            {
                text: "002",
                youtubeUrl: "https://www.youtube.com/embed/nDrGBERO2nI",
                name: 'pv002'
            },
            {
                text: "003",
                youtubeUrl: "https://www.youtube.com/embed/f4t6u8gwQDk",
                name: 'pv003'
            }
        ],
        linkList: [
            {
                icon: require("../../assets/images/home/top/facebook.png"),
                to: "https://www.facebook.com/ArknightsKorea"
            },
            {
                icon: require("../../assets/images/home/top/twitter.png"),
                to: "https://twitter.com/ArknightsKorea"
            },
            {
                icon: require("../../assets/images/home/top/cafe.png"),
                to: "https://cafe.naver.com/arknightskor"
            },
            {
                icon: require("../../assets/images/home/top/youtube.png"),
                to: "https://www.youtube.com/channel/UCnnbUv4urnbWgb_lgGUfeBw"
            }
        ],
        factionList: [
            {
                icon: require("../../assets/images/home/top/faction01.png"),
                open: true,
                youtubeUrl: "https://www.youtube.com/embed/htcmhISovbs",
                name: 'faction01'
            },
            {
                icon: require("../../assets/images/home/top/faction02.png"),
                open: true,
                youtubeUrl: "https://www.youtube.com/embed/AUefA44trgk",
                name: 'faction02'
            },
            {
                icon: require("../../assets/images/home/top/faction03.png"),
                open: true,
                youtubeUrl: "https://www.youtube.com/embed/8W_QqsRRKpE",
                name: 'faction03'
            },
            {
                icon: require("../../assets/images/home/top/faction04.png"),
                open: true,
                youtubeUrl: "https://www.youtube.com/embed/o7aQgpLtIAU",
                name: 'faction04'
            },
            {
                icon: require("../../assets/images/home/top/faction05.png"),
                open: true,
                youtubeUrl: "https://www.youtube.com/embed/1uM5AMps2OY",
                name: 'faction05'
            },
            {
                icon: require("../../assets/images/home/top/faction06.png"),
                open: true,
                youtubeUrl: "https://www.youtube.com/embed/bMnBPMZ78FI",
                name: 'faction06'
            },
            {
                icon: require("../../assets/images/home/top/faction07.png"),
                open: true,
                youtubeUrl: "https://www.youtube.com/embed/pR0QoT0lcY8",
                name: 'faction07'
            }
        ],
        currentVideo: 'pv001',
        videoPlayBtnActive: false,
    }),
    created() {
        //
        this.$store.commit("Mask/SET_VIDEO_MASK_ACTIVE", {
            show: false, 
            videoUrl: this.pvList[0].youtubeUrl
        })
    },
    mounted() {
    },
    watch: {

    },
    computed: {
        ...mapState({
            FULLPAGE: state => state.Home.FULLPAGE
        })
    },
    methods: {
        loaded() {
            console.log("video load")
        },
        showVideoMask() {
            this.$store.commit("Mask/SET_VIDEO_MASK_ACTIVE", {
                show: true, 
            })
        },
        updateVideo(open, item) {
            if(!open) {
                return false
            }
            if(item.icon) {
                this.videoPlayBtnActive = true
            } else {
                this.videoPlayBtnActive = false
            }
            
            this.currentVideo = item.name
            this.$store.commit("Mask/SET_VIDEO_MASK_ACTIVE", {
                show: false, 
                videoUrl: item.youtubeUrl
            })
        },
        jumpTo() {
            this.FULLPAGE.goTo(2)
        }
    },
};
</script>

<style lang="scss" scoped>
.home-top-page {
    background: #000;
    
    .bg {
        position: absolute;
        width: 100%;
        bottom: 0;
        z-index: 1;
        left: 50%;
        transform: translate(-50%, 0);
    }
    &::after {
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        background: url("../../assets/images/home/top/bg_texture.png");
        z-index: 3;
    }
    .video-bg {
        position: absolute;
        z-index: 2;
        width: auto;
        height: auto;
        min-width: 100%;
        min-height: 100%;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
    /* nav */
    .right-nav {
        position: absolute;
        z-index: 4;
        top: pxTorem(15px);
        right: pxTorem(26px);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;
        font-family: HelveticaInserat, sans-serif;

        .box-wrap {
            display: flex;
            justify-content: space-around;
            align-items: center;
        }
        
        .pv-box {
            order: 2;
            color: #fff;
            font-size: 0;
            .pv-box-tip {
                font-size: pxTorem(16px);
            }
            .pv-box-a {
                font-size: pxTorem(18px);
                margin-left: pxTorem(12px);
                opacity: 0.5;
                cursor: pointer;
                color: #fff;
                
                &.active {
                    opacity: 1;
                    border-bottom: 2px solid #06a3da;
                }
            }
        }
        .faction-box {
            order: 1;
            color: #fff;
            margin-right: pxTorem(25px);
            display: flex;
            align-items: center;
            
            .faction-box-tip {
                font-size: pxTorem(16px);
            }
            .faction-box-a {
                width: pxTorem(40px);
                margin-left: pxTorem(12px);
                cursor: pointer;
                display: flex;
                justify-content: center;
                align-items: center;
                
                img {
                    width: pxTorem(40px);
                    opacity: 0.15;
                }

                &.active {
                    img {
                        opacity: 1 !important;
                    }
                }
            }
        }
        .other-nav {
            width: pxTorem(30px);

            .link-box {
                width: 100%;
                img {
                    width: 100%;
                    opacity: 0.6;
                    transition: all 0.3s ease-in-out;
                }
                &:hover {
                    img {
                        opacity: 1;
                    }
                }
            }
        }
    }

    .btn-wrap {
        position: absolute;
        z-index: 4;
        left: 50%;
        bottom: pxTorem(52px);
        transform: translate(-50%);
        display: flex;
        flex-direction: column;
        align-items: center;
        
        .video-play-btn {
            width: pxTorem(98px);
            margin-bottom: pxTorem(130px);
            cursor: pointer;
            opacity: 0;
            transition: all .2s ease-in-out;
            
            &:hover {
                opacity: 1;
            }
            &.active {
                opacity: 1;
            }
        }
        .prereg-box {
            width: auto;
            height: pxTorem(258px);
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            
            .prereg-img {
                width: 100%;
            }
            // 删除黄色菱形
            // &::after {
            //     content: "";
            //     position: absolute;
            //     width: 80%;
            //     height: 80%;
            //     top: 50%;
            //     left: 50%;
            //     transform: translate(-50%, -50%) rotate(45deg);
            //     border: pxTorem(8px) solid #ffea00;
            //     z-index: -1;
            //     animation: news-scale 1s ease-out infinite;

            //     @keyframes news-scale {
            //         0% {
            //             transform: translate(-50%, -50%) rotate(45deg) scale(0.6);
            //             opacity: 1;
            //         }
            //         100% {
            //             transform: translate(-50%, -50%) rotate(45deg) scale(1);
            //             opacity: 0;
            //         }
            //     }
            // }

            .pre-ios {
                position: absolute;
                width: pxTorem(200px);
                right: 60%;
                z-index: 998;
                top: 50%;
                transform: translateY(-50%);
                // pointer-events: none;

                img {
                    display: block;
                    width: 100%;
                }

                /* &::after {
                    content: "";
                    display: block;
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    top: 0;
                    left: 0;
                    background: rgba(0, 0, 0, .7);
                    border-radius: 8px;
                    z-index: 1;
                }
                &::before {
                    content: "준비 중";
                    display: block;
                    position: absolute;
                    color: #fff;
                    font-family: 'Noto Sans KR', sans-serif;
                    font-weight: 700;
                    font-size: pxTorem(14px);
                    z-index: 2;
                    left: 50%;
                    top: 2%;
                    transform: translateX(-50%);
                } */
            }
            .pre-google {
                position: absolute;
                width: pxTorem(200px);
                left: 60%;
                z-index: 998;
                top: 50%;
                transform: translateY(-50%);

                img {
                    display: block;
                    width: 100%;
                }
            }
            
            .download-google {
                display: block;
                height: pxTorem(70px);
                z-index: 998;
                margin-right: pxTorem(30px);

                img {
                    display: block;
                    height: 100%;
                }
            }

            .download-one-store {
                @extend .download-google;
            }

            .download-samsung {
                @extend .download-google;
            }

            .download-ios {
                @extend .download-google;
                margin-right: 0;
            }
        }
    }
    .scroll-box {
        width: pxTorem(360px);
        position: absolute;
        z-index: 4;
        right: pxTorem(75px);
        bottom: 0%;

        .logo {
            width: 100%;
            margin-bottom: pxTorem(35px);
        }
        .mouse-box {
            width: pxTorem(30px);
            height: pxTorem(300px);
            position: relative;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            display: flex;
            flex-direction: column;

            &::before {
                content: "";
                display: block;
                width: 2px;
                background: #fff;
                height: pxTorem(300px);
                position: relative;
                left: 50%;
                transform: translateX(-50%);
                animation: FadeOut 3s ease-in-out infinite backwards;
            }

            .mouse-tip {
                width: pxTorem(30px);
                position: relative;
                left: 50%;
                transform: translateX(-50%);
                text-align: center;
                animation: FadeOut 3s ease-in-out infinite backwards;

                .mouse {
                    width: pxTorem(20px);
                }

                &::before {
                    content: "scroll";
                    position: absolute;
                    transform-origin: left top;
                    transform: translate(pxTorem(-4px), pxTorem(0px)) rotateZ(90deg);
                    color: #fff;
                    text-transform: uppercase;
                    font-size: pxTorem(12px);
                }

                &::after {
                    content: "";
                    display: block;
                    width: 2px;
                    background: #fff;
                    height: pxTorem(280px);
                    position: relative;
                    left: 50%;
                    transform: translateX(-50%);
                    animation: translt 3s ease-in-out infinite backwards;
                    ;
                }

                @keyframes translt {
                    0% {
                        height: pxTorem(200px);
                    }
                    100% {
                        height: pxTorem(20px);
                    }
                }
            }

            @keyframes FadeOut {
                0% {
                    opacity: 0;
                }
                10% {
                    opacity: 1;
                }
                90% {
                    opacity: 1;
                }
                100% {
                    opacity: 0;
                }
            }
        }
    }
}
</style>
